import styled from "styled-components"

import { Typography } from "components/common"

export const PageTitle = styled(Typography).attrs((props) => ({
  as: "h1",
  fontWeight: "normal",
  textAlign: "center",
  variant: "h1",
  ...props,
}))``

export const SectionTitle = styled(Typography).attrs((props) => ({
  as: "h2",
  fontWeight: "normal",
  mt: 2,
  variant: "h2",
  ...props,
}))``

export const SectionSubTitle = styled(Typography).attrs((props) => ({
  as: "h3",
  fontWeight: "normal",
  mt: 1,
  variant: "h3",
  ...props,
}))``

export const Paragraph = styled(Typography).attrs((props) => ({
  as: "p",
  mt: 1,
  variant: "body3",
  ...props,
}))``
